import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import ErrorBoundary from 'components/ErrorBoundary'
import LicenseSearch from './search/LicenseSearch'
import License from './License'

export default class LicenseManager extends Component {
  render = () => {
    const { match } = this.props

    return (
      <ErrorBoundary>
        <Switch>
          <Route component={License} path={`${match.path}/:id`} />
          <Route component={LicenseSearch} path={match.path} />
        </Switch>
      </ErrorBoundary>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/css-admin/licenses/LicenseManager.js